import Loadable from 'app/components/Loadable';
import { lazy } from 'react';
import { authRoles } from '../../auth/authRoles';

const RewardList = Loadable(lazy(() => import('./RewardList')));
const AddReward = Loadable(lazy(() => import('./AddReward')));
const PrivateRoute = Loadable(lazy(() => import('../../auth/PrivateRoute')));

const RewardRoutes = [
  {
    path: '/reward/list',
    element: (
      //<PrivateRoute pageUrl="RewardMaster" requiredFunc="VIE">
        <RewardList />
      //</PrivateRoute>
    ),
    auth: authRoles.admin,
  },
  {
    path: '/reward/manage',
    element: (
      <PrivateRoute pageUrl="RewardMaster" requiredFunc="ADD">
        <AddReward />
      </PrivateRoute>
    ),
    auth: authRoles.admin,
  },
];

export default RewardRoutes;
